import React, { useState } from 'react';
import {
  Form, DatePicker, Button, Radio, Input, InputNumber,
  message, Upload, Tooltip, Popconfirm, Row, Col, Icon,
  Modal, Popover, Divider
} from 'antd';

const template = require('./template.xlsx');

const ImportForm = (props) => {
  const token = localStorage.getItem(`xb_${process.env.APP_MODE}_token`)

  const uploadProps = {
    name: 'file',
    action: process.env.API_PREFIX + '/importOrders',
    accept: ".xlsx",
    headers: {
      Authorization: 'Bearer ' + token,
    },
    beforeUpload: (file, fileList) => {
      const { name } = file;
      let isExcel = /xlsx$/i.test(name);

      if (!isExcel) {
        message.error(`仅支持.xlsx格式的文件!`);

      }
      return isExcel
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`导入成功`);
        props.submit();
      } else if (info.file.status === 'error') {
        message.error(`导入失败`);
      }
    },
  };

  return (
    <>
      <Divider dashed />
      <p>表格模版：批量创建工单表格模版.xlsx <Button type="link"
        href={template} download="批量创建工单表格模版"

      >点击下载表格模版</Button></p>
      <div>
        <span style={{ color: 'red' }}>*</span>上传工单表格：
        <Upload {...uploadProps}>
          <Button type="primary" ghost>
            <Icon type="upload" />点击上传
          </Button>
        </Upload>
      </div>
    </>
  )
}
export default ImportForm